import { render, staticRenderFns } from "./JitsiMeeting.vue?vue&type=template&id=3cc8da80&"
import script from "./JitsiMeeting.vue?vue&type=script&lang=js&"
export * from "./JitsiMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports